import Vue from 'vue'

function downloadsReceived(state, data) {
  /*const contractId = state.settings.contractData.contractId
    const contract = data.list.find(c => {
        return c.vertragsnummer === contractId
    })*/
  let downloads = []
  //downloads = data
  /*downloads.push(
        {name: 'myName', url: 'https://bla.bla', date: new Date()}
    );*/
  /*
    contract.get_rechnungen_simple.map(rawInvoice => {
        downloads.push({
            name: rawInvoice.nummer,
            url: rawInvoice.get_dokumenteliste.pop().get_dokument_httplink,
            date: new Date(parseInt(rawInvoice.datum, 10) * 1000),
        })
    })*/

  /*
    {name: '',
           url: state.urls.backend + '/app/getFormattedReads' +
               '?cubeName=' + state.cube.name
               + '&efToken=' + state.authentication.backendAccessToken
               + '&startTime=2019-01-01&endTime=2019-02-01'
           ,
           date: new Date('2019-01-01')},
     */

  for (let year in data.data) {
    for (let month in data.data[year]) {
      downloads.push({
        dailyUrl:
          state.urls.backend +
          data.data[year][month].linkDaily.href +
          '&efToken=' +
          state.authentication.backendAccessToken,
        dailyCaption: data.data[year][month].linkDaily.caption,
        fifteenMinUrl:
          state.urls.backend +
          data.data[year][month].link15Min.href +
          '&efToken=' +
          state.authentication.backendAccessToken,
        fifteenMinCaption: data.data[year][month].link15Min.caption,
        caption: data.data[year][month].caption,
      })
    }
  }

  Vue.set(state.settings, 'downloads', downloads)
}

function selectDownloadYear(state, year) {
  Vue.set(state.settings, 'selectedDownloadYear', year)
}

export default {
  downloadsReceived,
  selectDownloadYear,
}
